import { Component, Input, OnInit } from '@angular/core';
import { Splitter, UnbalancedBox, VerticalBuildingType } from '../../state/network-parameters.model.generated';
import { VERTICAL_UNBALANCED_ATTENDANCE_SPLITTER } from '../../state/simulation.service';

@Component({
  selector: 'app-diagram-group',
  templateUrl: './diagram-group.component.html',
  styleUrls: ['./diagram-group.component.scss']
})
export class DiagramGroupComponent implements OnInit {

  @Input()
  types: VerticalBuildingType[];

  items: TypeData[] = [];

  readonly attendanceSplitter: Splitter = VERTICAL_UNBALANCED_ATTENDANCE_SPLITTER;

  constructor() { }

  ngOnInit(): void {
    this.types.forEach((type) => {
      const splitters = this.getSplitters(type);
      const internal = this.getInternal(type);
      const boxes = this.getBoxes(type);

      this.items.push({ splitters, internal, boxes });
    });
  }

  private getSplitters(type: VerticalBuildingType): Splitter[] {
    const splitters: Splitter[] = [];

    // if (type.configuration.network_type === 'unbalanced') {
    //   splitters.push(this.attendanceSplitter);
    // }
    type.configuration.splitter_sections.forEach(section => {
      splitters.push(section.splitter);
    });

    return splitters;
  }

  private getInternal(type: VerticalBuildingType): number {
    let internal = 0;
    type.configuration.splitter_sections.forEach(section => {
      if (section.can_use_internally) {
        internal++;
      }
    });
    return internal;
  }

  private getBoxes(type: VerticalBuildingType): UnbalancedBox[] {
    return type.configuration.bus_box_types;
  }

}

interface TypeData {
  splitters: Splitter[];
  internal: number;
  boxes: UnbalancedBox[];
}
